import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import ThemeToggle from "./components/ThemeToggle";
import Navigation from "./components/Navigation";
import Home from "./components/Home";
import Team from "./components/Team";
import Contact from "./components/Contact";
import Background from './components/Background';
import Logo from './components/Logo';

const Layout = ({ theme, children }) => (
    <div className={`min-h-screen ${theme === 'tech' ? 'text-green-400' : 'text-gray-800'}`}>
        <Background theme={theme} />
        <div className="container mx-auto px-4 py-8">
            <div className="flex justify-center mb-12">
                <Logo theme={theme} />
            </div>
            <Navigation theme={theme} />
            <div className="mt-8">
                {children}
            </div>
        </div>
    </div>
);

const App = () => {
  const [theme, setTheme] = useState('tech');

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      setTheme(savedTheme);
    }
  }, []);

  const handleThemeChange = (newTheme) => {
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
  };

  return (
    <Router>
      <Layout theme={theme}>
        <ThemeToggle theme={theme} onThemeChange={handleThemeChange} />
        <Routes>
          <Route path="/" element={<Home theme={theme} />} />
          <Route path="/team" element={<Team theme={theme} />} />
          <Route path="/contact" element={<Contact theme={theme} />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;